import { Link } from 'react-router-dom';
import SiteLayout from './SiteLayout';
import { IconArrow } from './icons';

const STATS = [
  { b: 'Estágio→Sênior', s: 'um caminho de carreira guiado, do início ao topo' },
  { b: '100%', s: 'prático — labs e projetos em todo módulo' },
  { b: '0', s: 'burocracia. Direto ao ponto, no seu ritmo' },
];

const VALUES = [
  { tag: 'princípio 01', t: 'Descomplicar', d: 'Menos jargão e burocracia, mais clareza. Se dá pra simplificar, a gente simplifica.' },
  { tag: 'princípio 02', t: 'Pensamento de Engenheiro', d: 'Ensinamos a pensar, não a decorar. O raciocínio fica; o comando a gente sempre esquece.' },
  { tag: 'princípio 03', t: 'Prática de verdade', d: 'Você aprende com a mão no teclado, em labs e projetos parecidos com o trabalho real.' },
  { tag: 'princípio 04', t: 'Do seu lado', d: 'Um caminho guiado do estágio ao sênior. Você sempre sabe o próximo passo e nunca fica perdido.' },
];

export default function QuemSomos() {
  return (
    <SiteLayout>
      <section className="cc-phero">
        <div className="cc-hero-orb o1" />
        <div className="cc-wrap cc-hero-copy">
          <span className="cc-eyebrow">quem somos</span>
          <h1 className="cc-h1">A escola do <span className="cc-serif">Pensamento de Engenheiro</span>.</h1>
          <p className="cc-hero-sub">
            A Cloud Café &amp; DevOps existe pra guiar quem está começando em tecnologia até virar sênior —
            de forma prática, simples e sem burocracia.
          </p>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap cc-split">
          <div className="cc-reveal">
            <div className="cc-prose">
              <p><strong>Começar em tecnologia é confuso.</strong> Muita ferramenta, muito curso teórico e
              pouca gente pra dizer, na ordem certa, o que estudar pra sair do estágio e crescer.</p>
              <p>A gente montou o caminho que queria ter tido: uma trilha guiada <strong>do estágio ao sênior</strong>,
              focada em desenvolver o <strong>Pensamento de Engenheiro</strong> — o Mindset P.E. Menos decoreba,
              mais raciocínio; menos slide, mais terminal.</p>
              <p>Nossa régua é simples: se não descomplica a sua evolução, não entra. Direto ao ponto,
              prático e no seu ritmo.</p>
            </div>
          </div>
          <div className="cc-reveal">
            <div className="cc-stats">
              {STATS.map((x) => (
                <div className="cc-stat" key={x.s}><b>{x.b}</b><span>{x.s}</span></div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          <div className="cc-reveal">
            <span className="cc-eyebrow">no que acreditamos</span>
            <h2 className="cc-h2" style={{ marginBottom: 36 }}>Nossos princípios</h2>
          </div>
          <div className="cc-values">
            {VALUES.map((v) => (
              <div className="cc-value cc-reveal" key={v.t}>
                <span className="cc-vtag">{v.tag}</span>
                <h3>{v.t}</h3>
                <p>{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          <div className="cc-cta cc-reveal">
            <h2>Bora começar sua evolução?</h2>
            <p>A primeira trilha é por nossa conta. Crie sua conta grátis e dê o primeiro passo do estágio ao sênior.</p>
            <div className="cc-cta-actions">
              <Link className="cc-btn cc-btn-primary" to="/treinamentos/cadastro">Criar conta grátis <IconArrow /></Link>
              <Link className="cc-btn cc-btn-ghost" to="/objetivo">Nosso objetivo</Link>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
